module.exports = __webpack_public_path__ + "static/media/Satoshi-Regular.71a6023c.woff2";